import {action, observable} from 'mobx'
import {observer} from 'mobx-react'
import React, {Component} from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Grid from '../components/Grid'
import styled from 'styled-components'
import request from "../utils/request";

const PlaylistLink = styled.a`
    display: flex;
    background: var(--${props => props.disabled ? 'gray' : props.color});
    color: #fff;
    padding: 0.75rem 1.25rem;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    transition: all 0.2s;
    font-weight: 300;
    border-radius: 1.25rem;
    width: 100%;
    text-decoration: none;
    text-align: center;
    align-items: center;
    justify-content: center;

    &:hover {
        box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
    }
`

@observer
export default class ArchivedResources extends Component {
  @observable miTrainer = null
  @observable archiveViewer = null

  @action
  setMiTrainer = miTrainer => this.miTrainer = miTrainer
  @action
  setArchiveViewer = archiveViewer => this.archiveViewer = archiveViewer

  getPermission = async () => {
    const req = await request('/api/user/getFields')

    if (req.success) {
      this.setMiTrainer(req.data.fields.miTrainer)
      this.setArchiveViewer(req.data.fields.archiveViewer)
    }
  }

  componentDidMount() {
    this.getPermission().then()
  }

  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        {this.miTrainer ? <DashboardLayout title="Archived Resources" backHref="/resources" backText="Resources">
          <Grid>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="/resources/archived-resources/pre-training">Archived Participants Pre-Training
                Materials</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="/resources/archived-resources/see-training-ppts">Archived SEE MI Training PPTs</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="/resources/archived-resources/see-training-materials">Archived SEE MI Training
                Materials</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/drive/u/2/folders/1-UbnZoS3KKzYO2gkBFjFDFOdxJBgl9OK" target='_blank'>Updated Edited MI Training Materials</PlaylistLink>
            </Grid.HalfCell>
          </Grid>
        </DashboardLayout> : false}
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/ArchivedResources.js